import { render, staticRenderFns } from "./RecommendModule.vue?vue&type=template&id=39cae319&scoped=true&"
import script from "./RecommendModule.vue?vue&type=script&lang=js&"
export * from "./RecommendModule.vue?vue&type=script&lang=js&"
import style0 from "./RecommendModule.vue?vue&type=style&index=0&lang=less&"
import style1 from "./RecommendModule.vue?vue&type=style&index=1&id=39cae319&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cae319",
  null
  
)

export default component.exports